import {
  AbstractControl,
  UntypedFormControl,
  ValidationErrors,
} from '@angular/forms';

export class CustomValidators {

  private static emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  private static isEmpty(value: any): boolean {
    return value === undefined
      || value === null
      || value.toString() === '';
  }

  public static required(control: AbstractControl): ValidationErrors | null {
    const formControl = control as UntypedFormControl;
    const value = formControl.value;

    return value === undefined || value === null || value.toString().trim() === ''
      ? {required: true}
      : null;
  }

  public static emails(control: AbstractControl): ValidationErrors | null {
    const formControl = control as UntypedFormControl;
    const value = formControl.value as string;

    if (CustomValidators.isEmpty(value)) {
      return null;
    }

    const parts = value.split(';');
    let isValid = true;

    parts.forEach(part => {
      if (!part.trim().toLowerCase().match(CustomValidators.emailRegExp)) {
        isValid = false;
      }
    });

    return isValid
      ? null
      : {emails: true};
  }

  static phoneNumber(formControl: AbstractControl): ValidationErrors | null {
    const value: string = formControl.value;
    const regExp = /\+7 \d{3} \d{3}-\d{2}-\d{2}$/;

    if (value?.length < 1) { return null; }

    return !value?.match(regExp)
      ? { phoneNumber: true }
      : null;
  }
}
